import * as React from 'react';
import { SvgIcon, SvgIconBaseProps } from '../components/SvgIcon/SvgIcon';

export function PlusIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path d="M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z" />
        </SvgIcon>
    );
}
